






















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Warning from '@/components/page/Warning.vue';
import PageScope from '@/components/common/PageScope.vue';
import PGRowBooleanValue from '@/components/common/property/PGRowBooleanValue.vue';
import { UIPage } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIPage';
import { UIModelComponent } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { UIView } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIView';
import { EVOAttribute } from '@/api/com/MetaPattern/MDA/MD/UIModel/EVOAttribute';
import { EnumViewType, EnumViewTypeMD } from '@/api/com/MetaPattern/MDA/MD/UIModel/EnumViewType';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { UIButton } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIButton';
import { PageView } from '@/api/com/MetaPattern/MDA/MD/UIModel/PageView';

@Component({
  components: {
    Warning,
    PageScope,
    PGRowBooleanValue
  }
})
export default class UIModel extends Vue {
  @Prop() page!: UIPage; // 頁面
  @Prop() curComponent!: UIModelComponent; // UI模型
  private selectedEVOAttributeId: string; // 选中的实体模型属性
  private selectedButtonId: string; // 选中的按钮

  constructor() {
    super();
    this.selectedEVOAttributeId = '';
    this.selectedButtonId = '';
  }

  /** 获取当前页面对应的页面视图 */
  get pageViews() {
    const views = new Array<PageView>();
    if (this.page !== null) {
      this.curComponent.pageViews.forEach(pageView => {
        if (pageView.page_ID === this.page.id && !pageView.removed) {
          views.push(pageView);
        }
      });
    }
    return views;
  }

  getViewType(view: UIView) {
    return EnumViewTypeMD.getItem(view.viewType).displayName;
  }

  /** 选中元素的事件处理 */
  selectElement(element: BaseElement) {
    if (element) {
      this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', element.designId);
      this.$store.dispatch('ModuleMD/setCurMDElementAction', { element: element });
    }
  }

  needLoginChange(value: boolean) {
    this.page.needLogin = value;
    this.page.modify();
    this.curComponent.modify();
  }

  /** 获取页面可移除的视图 */
  getRemovablePageViews(page: UIPage) {
    return this.curComponent.pageViews.filter(item => item.page_ID === page.id && item.isRemovable);
  }

  /** 页面视图是否隐藏 */
  pageViewRemovedChange(pageView: PageView) {
    pageView.removed = !pageView.removed;
    this.page.modify();
    this.curComponent.modify();
  }

  /** 根据视图类型，返回对应的视图属性 */
  getAttributes(view: UIView) {
    let attributes: Array<EVOAttribute> = null;
    switch (view.viewType) {
      case EnumViewType.Modify:
        attributes = view.viewObject.attributes.filter(item => (item.canCreate || item.canEdit) && item.persistenceStatus !== EnumPersistenceStatus.Delete);
        break;
      case EnumViewType.Detail:
        attributes = view.viewObject.attributes.filter(item => item.isInDetail && item.persistenceStatus !== EnumPersistenceStatus.Delete);
        break;
      case EnumViewType.List:
      case EnumViewType.Tree:
        attributes = view.viewObject.attributes.filter(item => item.isInList && item.persistenceStatus !== EnumPersistenceStatus.Delete);
        break;
      case EnumViewType.Search:
        attributes = view.viewObject.attributes.filter(item => item.isSearch && item.persistenceStatus !== EnumPersistenceStatus.Delete);
        break;
      case EnumViewType.Custom:
      default:
        attributes = view.viewObject.attributes;
        break;
    }
    return attributes;
  }

  /** 根据视图类型，返回尚未添加的视图属性 */
  getAttributeOptions(view: UIView) {
    let attributes: Array<EVOAttribute>;
    switch (view.viewType) {
      case EnumViewType.Modify:
        attributes = view.viewObject.attributes.filter(item => (!item.canCreate && !item.canEdit) && item.persistenceStatus !== EnumPersistenceStatus.Delete);
        break;
      case EnumViewType.Detail:
        attributes = view.viewObject.attributes.filter(item => !item.isInDetail && item.persistenceStatus !== EnumPersistenceStatus.Delete);
        break;
      case EnumViewType.List:
      case EnumViewType.Tree:
        attributes = view.viewObject.attributes.filter(item => !item.isInList && item.persistenceStatus !== EnumPersistenceStatus.Delete);
        break;
      case EnumViewType.Search:
        attributes = view.viewObject.attributes.filter(item => !item.isSearch && item.persistenceStatus !== EnumPersistenceStatus.Delete);
        break;
      case EnumViewType.Custom:
      default:
        attributes = new Array<EVOAttribute>();
        break;
    }
    return attributes;
  }

  /** 添加实体视图属性 */
  AddEVOAttributeId(view: UIView) {
    if (this.selectedEVOAttributeId !== '') {
      const addAttribute = view.viewObject.attributes.find(item => item.id === this.selectedEVOAttributeId && item.persistenceStatus !== EnumPersistenceStatus.Delete);
      if (addAttribute) {
        switch (view.viewType) {
          case EnumViewType.Modify:
            addAttribute.canEdit = true;
            addAttribute.canCreate = true;
            break;
          case EnumViewType.Detail:
            addAttribute.isInDetail = true;
            break;
          case EnumViewType.List:
          case EnumViewType.Tree:
            addAttribute.isInList = true;
            break;
          case EnumViewType.Search:
            addAttribute.isSearch = true;
            break;
          case EnumViewType.Custom:
          default:
            break;
        }
        addAttribute.modify();
        this.curComponent.modify();
      }
      this.selectedEVOAttributeId = '';
    }
  }

  /** 删除视图属性标签的事件 */
  removeAttributeTag(view: UIView, attribute: EVOAttribute) {
    switch (view.viewType) {
      case EnumViewType.Modify:
        attribute.canCreate = false;
        attribute.canEdit = false;
        break;
      case EnumViewType.Detail:
        attribute.isInDetail = false;
        break;
      case EnumViewType.List:
      case EnumViewType.Tree:
        attribute.isInList = false;
        break;
      case EnumViewType.Search:
        attribute.isSearch = false;
        break;
      case EnumViewType.Custom:
      default:
        break;
    }
    attribute.modify();
    this.curComponent.modify();
  }

  /** 获取未移除的视图按钮 */
  getViewButtons(view: UIView) {
    return this.curComponent.buttons.filter(button => button.view_ID === view.id && button.isValid && !button.removed);
  }

  /** 根据视图类型，返回尚未添加的按钮 */
  getViewButtonOptions(view: UIView) {
    return this.curComponent.buttons.filter(button => button.view_ID === view.id && button.isValid && button.removed);
  }

  /** 获取所有的视图按钮 */
  getAllViewButtons(view: UIView) {
    return this.curComponent.buttons.filter(button => button.view_ID === view.id && button.isValid);
  }

  /** 添加视图按钮 */
  AddViewButtonId(view: UIView) {
    if (this.selectedButtonId !== '') {
      const addButton = this.curComponent.buttons.find(item => item.id === this.selectedButtonId && item.isValid);
      if (addButton) {
        addButton.removed = false;
        addButton.modify();
        this.curComponent.modify();
      }
      this.selectedButtonId = '';
    }
  }

  /** 删除实体按钮标签的事件 */
  removeViewButtonTag(button: UIButton) {
    button.removed = true;
    button.modify();
    this.curComponent.modify();
  }

  /** 获取未移除的页面按钮 */
  getPageButtons(page: UIPage) {
    return this.curComponent.buttons.filter(button => button.page_ID === page.id && button.isValid && !button.removed);
  }

  /** 返回尚未添加的页面按钮 */
  getPageButtonOptions(page: UIPage) {
    return this.curComponent.buttons.filter(button => button.page_ID === page.id && button.isValid && button.removed);
  }

  /** 获取所有的页面按钮 */
  getAllPageButtons(page: UIPage) {
    return this.curComponent.buttons.filter(button => button.page_ID === page.id && button.isValid);
  }

  /** 添加页面按钮 */
  AddPageButtonId() {
    if (this.selectedButtonId !== '') {
      const addButton = this.curComponent.buttons.find(item => item.id === this.selectedButtonId && item.isValid);
      if (addButton) {
        addButton.removed = false;
        addButton.modify();
        this.curComponent.modify();
      }
      this.selectedButtonId = '';
    }
  }

  /** 删除页面按钮标签的事件 */
  removePageButtonTag(button: UIButton) {
    button.removed = true;
    button.modify();
    this.curComponent.modify();
  }
}
